import { FileText } from "lucide-react";
import { EntityLink, EntityLinkPlain } from "./EntityLink";

/**
 * ContractLink — canonical contract-number rendering, e.g. "45101", linking to
 * the contract detail page. Falls back to plain text when `contractId` is
 * missing. When no contract number is known, an optional `fallbackLabel`
 * (e.g. a tariff name) is used so the row still reads sensibly.
 */
export interface ContractLinkProps {
  contractId?: string | null;
  contractNumber?: string | number | null;
  /** Shown when contractNumber is absent (e.g. tariff name). */
  fallbackLabel?: string;
  className?: string;
  "data-testid"?: string;
}

export function ContractLink({
  contractId,
  contractNumber,
  fallbackLabel,
  className,
  "data-testid": dataTestId,
}: ContractLinkProps) {
  const label =
    contractNumber != null && String(contractNumber).length > 0
      ? String(contractNumber)
      : (fallbackLabel ?? "—");
  if (!contractId) {
    return (
      <EntityLinkPlain
        icon={FileText}
        title={label}
        className={className}
        data-testid={dataTestId}
      >
        {label}
      </EntityLinkPlain>
    );
  }
  return (
    <EntityLink
      to={`/contracts/${contractId}/edit`}
      icon={FileText}
      title={label}
      className={className}
      data-testid={dataTestId}
    >
      {label}
    </EntityLink>
  );
}
